import { render, staticRenderFns } from "./control3Phoneticalphabet.vue?vue&type=template&id=222103aa&scoped=true&"
import script from "./control3Phoneticalphabet.vue?vue&type=script&lang=js&"
export * from "./control3Phoneticalphabet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222103aa",
  null
  
)

export default component.exports